import React from "react";
import {hotelActivityService} from "../../jwt/_services/hotel/hotelActivityService";

export const hotelActivityProvider = {
    getOptions
}

async function getOptions(customFilter) {
    try {
        const listItems = await hotelActivityService.getOptions( customFilter );

        listItems.data.sort((a, b) => a.title.localeCompare(b.title));

        return listItems.data.map((item) => {
            return (
                {
                    id: item?.id,
                    value: item?.code,
                    label: <label>{ item?.title }</label>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}